const c = (e) => typeof e == "object" && e !== null && !Array.isArray(e);
function n(e, ...i) {
  if (!i.length)
    return e;
  const s = i.shift();
  return c(e) && c(s) && Object.keys(s).forEach((o) => {
    c(s[o]) ? (e[o] || Object.assign(e, { [o]: {} }), n(e[o], s[o])) : Object.assign(e, { [o]: s[o] });
  }), n(e, ...i);
}
const f = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isObject: c,
  mergeDeep: n
}, Symbol.toStringTag, { value: "Module" }));
export {
  c as i,
  n as m,
  f as o
};
